module.exports = __webpack_public_path__ + "img/12.3781d66e.png";